// ============================================================================
// FACILITY DTOs for Contractor App
// Matches backend FacilityDTOs.cs structure
// ============================================================================

// Import and re-export shared DTOs
import {
  PagedResultDto,
  FacilityContactDto,
  FacilityClassification,
  FacilityDto
} from '@umss/shared/data-access';
export type { PagedResultDto, FacilityContactDto };

// ============================================================================
// SEARCH DTOs
// ============================================================================

/**
 * Search parameters for facilities
 */
export interface FacilitySearchDto {
  searchTerm?: string;
  corporateId?: string;
  facilityIds?: string[];
  classification?: FacilityClassification;
  isActive?: boolean;
  facilityTypeId?: number;
  stateCode?: string;
  latitude?: number;
  longitude?: number;
  radiusMiles?: number;
  maxDistanceMiles?: number;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string;
  isFavorite?: boolean;
  sortDescending?: boolean;
}

// ============================================================================
// VIEW MODELS for Facility List Component
// ============================================================================

/**
 * Simplified facility data for list/table display
 */
export interface FacilityListItemDto {
  id: string;
  name: string;
  type: string;
  classification: string;
  state: string;
  city: string;
  distanceFromHome?: number;
  isFavorite: boolean;
  address?: string;
  email?: string;
  phone?: string;
}

/**
 * Maps FacilityDto to FacilityListItemDto for table display
 */
export function mapFacilityToListItem(
  facility: FacilityDto
): FacilityListItemDto {
  return {
    id: facility.id,
    name: facility.name,
    type: facility.facilityTypeName || 'N/A',
    classification: facility.classificationDisplay,
    state: facility.location?.stateCode || '',
    city: facility.location?.city || '',
    distanceFromHome: facility.distanceMiles,
    isFavorite: facility.isFavorite ?? false,
    address:
      facility.location?.fullAddress ||
      facility.location?.addressLine1 + ' ' + facility.location?.addressLine2 ||
      '',
    email: facility.contactEmail,
    phone: facility.contactPhone
  };
}
